export default __webpack_public_path__ + "static/media/Gotham-Bold.f9a5c924.otf";